import React from 'react';
import RouteLink from 'flow/components/ui-components/RouteLink';
import useAppContext from 'flow/hooks/useAppContext';
import useVoicemail from 'flow/hooks/useVoicemail';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';

interface Props {
    extensionKey: ExtensionKey;
}

const VoicemailNotifications = ({ extensionKey }: Props) => {
    const { i18next } = useAppContext();
    const { voicemailSettings } = useVoicemail(extensionKey);

    const notificationTypes = () => {
        if (!voicemailSettings) {
            return;
        }

        const types = [];
        if (voicemailSettings.get('noticeEmail')) {
            types.push(i18next.t('option.email'));
        }

        if (voicemailSettings.get('noticeSMS')) {
            types.push(i18next.t('option.sms'));
        }

        return types.length > 0 ? types.join(', ') : i18next.t('option.none');
    };

    return (
        <RouteLink
            to={routes['settings.voicemail.notify']}
            description={notificationTypes()}
        >
            {i18next.t('settings.voicemail_notify')}
        </RouteLink>
    );
};

export default VoicemailNotifications;
